import { FlexContainer, Separator as _Separator } from '@taxdown/piccolo-web';
import styled from 'styled-components';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const ModalContainer = styled(FlexContainer)`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 99;
  background: ${({ theme: { colors } }) => colors.darken};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding: 0;
  }
`;
export const CloseButton = styled.button`
  cursor: pointer;
  svg {
    width: ${({ theme: { sizing } }) => sizing.fds_size_16};
    height: ${({ theme: { sizing } }) => sizing.fds_size_16};
  }
`;

export const ModalContent = styled(FlexContainer)`
  background: ${({ theme: { colors } }) => colors.white};
  padding: ${({ theme: { sizing } }) => sizing.fds_size_16};
  width: 375px;
  max-height: 600px;
  overflow-y: auto;
  overflow-x: hidden;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    border-top-right-radius: ${({ theme: { system } }) => system.fds_sys_borderradius_XL};
    border-top-left-radius: ${({ theme: { system } }) => system.fds_sys_borderradius_XL};
    width: 100%;
  }
`;

export const OptionsContainer = styled(FlexContainer)`
  margin-bottom: ${({ theme: { sizing } }) => sizing.fds_size_08};
`;

export const OptionCard = styled(FlexContainer)`
  border-radius: ${({ theme: { sizing } }) => sizing.fds_size_08};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;

export const SeparatorContext = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  bottom: 0;
`;
export const Separator = styled(_Separator)`
  display: none;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    cursor: pointer;
    display: flex;
    justify-content: center;
    width: ${({ theme: { components } }) => components.modals.fds_c_dragger_width};
    border: ${({ theme: { components } }) =>
      `1px solid ${components.modals.fds_c_modal_bottom_dragger_color}`};
    ::before,
    ::after {
      border: none;
    }
  }
`;

export const ContentVideo = styled.section`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56%;
`;

export const Video = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
